import React, { } from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useStockInAndOutModel } from "../stockInAndOutModel";
import useNavModel from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { selectedRowKeys, descTotal, ioFlag, rowsDescTotal, initPgCfg, searchParam, setIoFlag, loadData, exportEntry } = useStockInAndOutModel();
    const desc: IDescription[] = [
        {
            label: ioFlag ? "入库项数" : "出库项数",
            value: selectedRowKeys.length === 0 ? descTotal.num ?? 0 : rowsDescTotal.num ?? 0,
            color: DescriptionColorEnum.red
        },
        {
            label: ioFlag ? "入库总计" : "出库总计",
            value: selectedRowKeys.length === 0 ? descTotal.amount ?? 0 : rowsDescTotal.amount ?? 0,
            color: DescriptionColorEnum.green
        }
    ]
    const action = <>
        <Tooltip placement="topLeft" title={disableExportMsg}>
            <Button
                disabled={false}
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportEntry()}
            >导出</Button>
        </Tooltip>
    </>;
    const ioFlagRecord = (io: number) => {
        setIoFlag(io);
        loadData(initPgCfg, { ...searchParam, ioFlag: io });
    }
    const title = <>
        <Button
            className={`mr-5 ${ioFlag === 0 ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => ioFlagRecord(0)}
        >出库记录</Button>
        <Button
            className={`mr-5 ${ioFlag === 1 ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => ioFlagRecord(1)}
        >入库记录</Button>
    </>
    return (
        <>
            <YhBox style={{ marginBottom: "5px", paddingLeft: "10px" }}>{title}</YhBox>
            {/* <YhBox title="出入库记录明细" descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}> */}
            <YhBox action={action} style={{ height: 'calc(100vh - 240px)' }}>

                <DataTable />
            </YhBox>
        </>
    )
}